import { Button, Flex, Icon, Icons } from "@ir/ui";
import { Permissions } from "@src/domain/permissions";
import HasAnyPermission from "@src/presentation/components/permissions/HasAnyPermission";

interface MasterDataEditActionCellProps<T extends { name: string }> {
  entityId: unknown;
  entitiesById: ReadonlyMap<number, T>;
  onEdit: (entity: T) => void;
}

export function MasterDataEditActionCell<T extends { name: string }>({
  entityId,
  entitiesById,
  onEdit,
}: Readonly<MasterDataEditActionCellProps<T>>) {
  const entity = entitiesById.get(Number(entityId));
  if (!entity) return null;
  return (
    <HasAnyPermission requiredPermissions={[Permissions.MASTER_DATA_EDIT]}>
      <Flex align="center" justifyContent="center">
        <Button
          size="small"
          variant="outline"
          color="grey"
          aria-label={`Edit ${entity.name}`}
          onPress={() => onEdit(entity)}
        >
          <Icon name={Icons.Edit} size="small" />
        </Button>
      </Flex>
    </HasAnyPermission>
  );
}
